module.exports = __webpack_public_path__ + "operace-usnich-boltcu_1_after.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/llc/surgery/procedures/plasticka-chirurgie/operace-usnich-boltcu_1_after.jpg
// module id = 1211
// module chunks = 0